import DialogAlertConfirmDesactivation from "views/Configuracion/SettingsSpaceAdmin/components/RegisterSpaceForm/ToggleActiveDialogs/DialogAlertConfirmDesactivation";
import DialogErrorForFutureReservationsInDesactivate from "../Dialogs/DialogErrorForFutureReservationsInDesactivate";

const ToggleActiveDialogs = ({
	dialogs, cancelDesactivation,
	toggleActive
}) => {
	return (
		<>
			<DialogAlertConfirmDesactivation
				dialog={dialogs.dialogConfirmDesactivate}
				actions={{
					cancel: cancelDesactivation,
					confirm: () => toggleActive(false)
				}} />
			<DialogErrorForFutureReservationsInDesactivate
				dialog={dialogs.dialogErrorForFutureReservationsInDesactivation}/>
		</>
	);
}

export default ToggleActiveDialogs;